import LazyLoad from 'react-lazyload';
import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';

import { graphql } from 'gatsby';
import Img from 'gatsby-image';

import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

export const query = graphql`
  query {
    file(relativePath: { eq: "covers/brick-textures.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1800) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

const ThumbWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  overflow: hidden;
  grid-gap: 0.75rem;

  img {
    object-fit: cover;
    height: 200px;
    width: 100%;
  }
  a {
    box-shadow: none;

    color: #382757;
    transition: color 0.25s ease-out;
  }
  p {
    margin-bottom: 0;
  }

  @media (max-width: 650px) {
    grid-template-columns: 1fr 1fr;

    img {
      object-fit: fill;
    }
  }
`;

const PageTemplate = css`
  .header-image {
    margin-bottom: 4.5rem;
    box-shadow: 0 10px 20px -16px #382757;
  }

  .site-main {
    background #fff;
    padding-bottom: 4vw;
  }

  .post-content {
    max-width: 1000px;
    margin: 0 auto;
  }
  .post-content .large-key .key {
    font-size: 3rem;
    padding: 15px;
    margin-top: 20px;
    display: inline-block;
    border-radius: 6px;
  }
  .large-key {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 4rem;
  }

  @media(max-width: 400px) {
    .large-key {
      grid-template-columns: 1fr 1fr;
    }
  }

  h2::before {
    display: none !important;
  }
`;

const BrickTextures: React.FunctionComponent = ({ data }) => (
  <IndexLayout>
    <Helmet>
      <title>55 Free High-Resolution Brick Textures | Giggster Guide</title>
      <meta
        name="description"
        content="A collection of 55 free brick textures to use as backgrounds in your edits and composites in Photoshop to add a brick backdrop in post-production."
      />

      <meta property="og:site_name" content="Giggster Guide" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="55 Free High-Resolution Brick Textures" />
      <meta
        property="og:description"
        content="A collection of 55 free brick textures to use as backgrounds in your edits and composites in Photoshop to add a brick backdrop in post-production."
      />
      <meta property="og:url" content="https://giggster.com/guide/brick-textures/" />
      <meta property="og:image" content="https://giggster.com/guide/covers/brick-textures.jpg" />
      <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="55 Free High-Resolution Brick Textures" />
      <meta
        name="twitter:description"
        content="A collection of 55 free brick textures to use as backgrounds in your edits and composites in Photoshop to add a brick backdrop in post-production."
      />
      <meta name="twitter:url" content="https://giggster.com/guide/brick-textures/" />
      <meta name="twitter:image" content="https://giggster.com/guide/covers/brick-textures.jpg" />
      <meta name="twitter:site" content="@Giggster" />
      <meta name="twitter:creator" content="@Giggster" />
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>55 Free High-Resolution Brick Textures</PostFullTitle>
            <h2 className="b3">
              Add a brick background to your composites using one of these free brick textures.
            </h2>
            <Img
              className="header-image"
              fluid={data.file.childImageSharp.fluid}
              alt="Showing off some of the free brick textures"
            />

            {/*<ShareButtons
              title={'55 Free High-Resolution Brick Textures'}
              slug={'/brick-textures/'}
              imgSrc={'covers/brick-textures.jpg'}
            />*/}
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <p>
                The following is a collection of 55 high-resolution photos of brick textures. These
                are from real photographs, and all taken with a focal length of 50mm. These are
                perfect to use in composites to add a brick backdrop/background to your photos in
                post-production. You can teak the exposure, contrast and add a vignette to these
                textures so that they fit seamlessly into your composites.
              </p>

              <p>
                As you'll see I tried to find various types of colors of bricks to cover a good
                variety.
              </p>

             
              <hr />
          
              <h2 className="text-center">Free Brick Textures and Backgrounds</h2>
              <p>
                Below you can see thumbnails for the 55 brick textures. Just click on any of the
                thumbnails to download a full high-resolution version of the texture.
              </p>
              <ThumbWrapper>
                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-1.jpg"
                      rel="noreferrer noopener"
                    >
                      <img src="/guide/images/brick-textures/brick-texture-1.jpg" alt="Brick texture 1" />
                    </a>
                  </div>
                </LazyLoad>
                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-2.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-2.jpg" alt="Brick texture 2" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-3.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-3.jpg" alt="Brick texture 3" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-4.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-4.jpg" alt="Brick texture 4" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-5.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-5.jpg" alt="Brick texture 5" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-6.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-6.jpg" alt="Brick texture 6" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-7.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-7.jpg" alt="Brick texture 7" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-8.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-8.jpg" alt="Brick texture 8" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-9.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-9.jpg" alt="Brick texture 9" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-10.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-10.jpg" alt="Brick texture 10" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-11.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-11.jpg" alt="Brick texture 11" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-12.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-12.jpg" alt="Brick texture 12" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-13.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-13.jpg" alt="Brick texture 13" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-14.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-14.jpg" alt="Brick texture 14" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-15.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-15.jpg" alt="Brick texture 15" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-16.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-16.jpg" alt="Brick texture 16" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-17.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-17.jpg" alt="Brick texture 17" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-18.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-18.jpg" alt="Brick texture 18" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-19.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-19.jpg" alt="Brick texture 19" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-20.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-20.jpg" alt="Brick texture 20" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-21.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-21.jpg" alt="Brick texture 21" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-22.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-22.jpg" alt="Brick texture 22" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-23.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-23.jpg" alt="Brick texture 23" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-24.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-24.jpg" alt="Brick texture 24" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-25.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-25.jpg" alt="Brick texture 25" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-26.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-26.jpg" alt="Brick texture 26" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-27.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-27.jpg" alt="Brick texture 27" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-28.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-28.jpg" alt="Brick texture 28" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-29.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-29.jpg" alt="Brick texture 29" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-30.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-30.jpg" alt="Brick texture 30" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-31.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-31.jpg" alt="Brick texture 31" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-32.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-32.jpg" alt="Brick texture 32" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-33.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-33.jpg" alt="Brick texture 33" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-34.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-34.jpg" alt="Brick texture 34" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-35.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-35.jpg" alt="Brick texture 35" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-36.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-36.jpg" alt="Brick texture 36" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-37.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-37.jpg" alt="Brick texture 37" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-38.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-38.jpg" alt="Brick texture 38" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-39.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-39.jpg" alt="Brick texture 39" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-40.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-40.jpg" alt="Brick texture 40" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-41.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-41.jpg" alt="Brick texture 41" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-42.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-42.jpg" alt="Brick texture 42" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-43.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-43.jpg" alt="Brick texture 43" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-44.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-44.jpg" alt="Brick texture 44" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-45.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-45.jpg" alt="Brick texture 45" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-46.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-46.jpg" alt="Brick texture 46" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-47.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-47.jpg" alt="Brick texture 47" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-48.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-48.jpg" alt="Brick texture 48" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-49.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-49.jpg" alt="Brick texture 49" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-50.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-50.jpg" alt="Brick texture 50" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-51.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-51.jpg" alt="Brick texture 51" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-52.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-52.jpg" alt="Brick texture 52" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-53.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-53.jpg" alt="Brick texture 53" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-54.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-54.jpg" alt="Brick texture 54" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download="true"
                    href="https://purple11.s3.amazonaws.com/brick-textures/brick-texture-55.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/brick-textures/brick-texture-55.jpg" alt="Brick texture 55" />
                  </a>
                </LazyLoad>
              </ThumbWrapper>
            </div>
          </PostFullContent>
        </article>
        <MoreGoodies slug="brick textures" />
      </main>
      <BackToTop />
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default BrickTextures;
